import { makeVar } from '@apollo/client';
import { createContext } from 'react';

import { useGuardedContext } from '@/hooks/useGuardedContext';

export enum DebugLevel {
  DEFAULT = 1,
  VERBOSE = 2,
  ENHANCED = 3, // More detailed debug information, especially for PDF viewer components
}

export const DEBUG_LEVEL_COOKIE = 'lum_debug_level';

export const debugLevelVar = makeVar<DebugLevel | null>(null);

export interface DebugContextShape {
  debugLevel: DebugLevel | null;
}

export const DebugContext = createContext<DebugContextShape>({
  debugLevel: null,
});

export const useDebugContext = () => {
  return useGuardedContext(DebugContext, 'DebugContextProvider');
};
